import { config } from './config';
import { widget } from './widget';
import { options } from './options';
import { exported } from './exported';

export const reducers = { config, widget, options, exported };
